import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IUserMigrationService } from "services/UserMigrationService";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";

const initialState = {
  FailedUserEmails: new Array<string>(),
  IsLoading: false,
  ShowMigrationResults: false,
  ShowResendResults: false,
};

export const UsersMigrationSlice = createSlice({
  name: "userMigration",
  initialState,
  reducers: {
    setShowMigrationResults: (state, action) => {
      state.ShowMigrationResults = action.payload;
    },
    setShowResendResults: (state, action) => {
      state.ShowResendResults = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(migrateAllCoreAccounts.pending, (state) => {
        state.IsLoading = true;
      })
      .addCase(migrateAllCoreAccounts.rejected, (state) => {
        state.IsLoading = false;
      })
      .addCase(migrateAllCoreAccounts.fulfilled, (state, action) => {
        state.IsLoading = false;
        state.FailedUserEmails = action.payload;
        state.ShowMigrationResults = true;
      })
      .addCase(resendUserInvitiations.pending, (state) => {
        state.IsLoading = true;
      })
      .addCase(resendUserInvitiations.rejected, (state) => {
        state.IsLoading = false;
      })
      .addCase(resendUserInvitiations.fulfilled, (state) => {
        state.IsLoading = false;
        state.ShowResendResults = true;
      });
  },
});

export const { setShowMigrationResults, setShowResendResults } = UsersMigrationSlice.actions;

export const migrateAllCoreAccounts = createAsyncThunk("userMigration/MigrateAllCoreAccounts", async () => {
  const userMigrationService = container.get<IUserMigrationService>(SERVICE_TYPES.UserMigrationService);
  return await userMigrationService.migrateAllCoreAccounts();
});

export const resendUserInvitiations = createAsyncThunk("userMigration/ResendUserInvitiations", async () => {
  const userMigrationService = container.get<IUserMigrationService>(SERVICE_TYPES.UserMigrationService);
  return await userMigrationService.resendUserInvitations();
});

export const selectFailedUserEmails = (state: RootState) => state.userMigration.FailedUserEmails;
export const selectIsLoading = (state: RootState) => state.userMigration.IsLoading;
export const selectShowMigrationResults = (state: RootState) => state.userMigration.ShowMigrationResults;
export const selectShowResendResults = (state: RootState) => state.userMigration.ShowResendResults;

export default UsersMigrationSlice.reducer;
